import AllAltQuoteOffers from "./AllAltQuoteOffers";

export default AllAltQuoteOffers;
